import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

//import './styles.css'

let canvas, ctx,
	mouseX, mouseY, mouseDown = 0,
	lastX, lastY, size = 1;

class Sign extends React.Component {

	constructor(props) {

		super(props)

		this.state = {
			x: 0,
			y: 0
		};

	}

	componentDidMount() {

		canvas = this.refs.canvas;
		ctx = canvas.getContext("2d");

		// Attach the mousemove event handler
		// canvas.addEventListener('mousemove', this.ev_mousemove.bind(this), false);

		canvas.addEventListener('mousedown', this.onMouseDown.bind(this), false);
		canvas.addEventListener('mousemove', this.onMouseMove.bind(this), false);
		canvas.addEventListener('mouseup', this.onMouseUp.bind(this), false);
		canvas.addEventListener('mouseout', this.onMouseUp.bind(this), false);

		// canvas.addEventListener("touchstart", this.onMouseDown.bind(this), false);
		// canvas.addEventListener("touchmove", this.onMouseMove.bind(this), true);
		// canvas.addEventListener("touchend", this.onMouseUp.bind(this), false);

		// Set up touch events for mobile, etc
		let self = this;
		canvas.addEventListener("touchstart", function (e) {
			self.getMousePos(e)
			var touch = e.touches[0];
			var mouseEvent = new MouseEvent("mousedown", {
				clientX: touch.clientX,
				clientY: touch.clientY
			});
			canvas.dispatchEvent(mouseEvent);
		}, false);

		canvas.addEventListener("touchend", function (e) {
			var mouseEvent = new MouseEvent("mouseup", {});
			canvas.dispatchEvent(mouseEvent);
		}, false);

		canvas.addEventListener("touchmove", function (e) {
			var touch = e.touches[0];
			console.log('x', touch.clientX);
			console.log('y', touch.clientY);
			console.log(touch)
			var mouseEvent = new MouseEvent("mousemove", {
				clientX: touch.clientX,
				clientY: touch.clientY
			});
			canvas.dispatchEvent(mouseEvent);
		}, false);

		// Prevent scrolling when touching the canvas
		document.body.addEventListener("touchstart", function (e) {
			if (e.target == canvas) {
				e.preventDefault();
			}
		}, false);
		document.body.addEventListener("touchend", function (e) {
			if (e.target == canvas) {
				e.preventDefault();
			}
		}, false);
		document.body.addEventListener("touchmove", function (e) {
			if (e.target == canvas) {
				e.preventDefault();
			}
		}, false);
}

	onMouseDown() {
		mouseDown = 1
		this.draw(mouseX, mouseY)
	}

	onMouseUp() {

		mouseDown = 0;
		lastX = 0;
		lastY = 0;

	}

	onMouseMove(e) {

		this.getMousePos(e)
		if (mouseDown == 1) {
			this.draw(mouseX, mouseY)
		}
	}

	getMousePos(e) {

		if (!e)
			var e = e;

		// if (e.offsetX) {
		// 	mouseX = e.offsetX
		// 	mouseY = e.offsetY
		// }
		// else if (e.layerX) {
		// 	mouseX = e.layerX
		// 	mouseY = e.layerY
		// }

		var rect = canvas.getBoundingClientRect();
		// return {
		mouseX = e.clientX - rect.left,
		mouseY = e.clientY - rect.top
		// };

	}

	draw(x, y) {

		if (lastX && lastY && (x !== lastX || y !== lastY)) {

			ctx.fillStyle = "#000000";
			ctx.lineWidth = 2 * size;
			ctx.beginPath();
			ctx.moveTo(lastX, lastY);
			ctx.lineTo(x, y);
			ctx.stroke();

		}

		ctx.fillStyle = "#000000";
		ctx.beginPath();
		ctx.arc(x, y, size, 0, Math.PI*2, true);
		ctx.closePath();
		ctx.fill();
		lastX = x;
		lastY = y;

		this.setState({
			x: mouseX,
			y: mouseY
		});

	}

	render() {

		return(
			<div className="sketchpadapp">
				<canvas ref="canvas"  width="500" height="150" className="myCanvas" />
			</div>
		)
	}

}

Sign.defaultProps = {
	isOpen: false,
	className: "modal3DFlipVertical modal-lg"
} 

export default Sign


// WEBPACK FOOTER //
// ./src/components/sign/index.js